import { useTranslation } from 'next-i18next';

import { Link } from '@chakra-ui/react';

import { Image } from '@nocowanie/common-ui/components/atoms/image';

import { AppPromotionLinkProps } from './app-promotion-link.props';
import { getAppPromotionLinkProps } from './app-promotion-link.utils';

export const AppPromotionLink = ({ platform, isMobile = false }: AppPromotionLinkProps) => {
    const { href, alt, src, htmlWidth, htmlHeight } = getAppPromotionLinkProps(platform, isMobile);
    const { t } = useTranslation('common', { keyPrefix: 'appPromotion' });
    return (
        <Link href={href} target="_blank" rel="noopener noreferrer">
            <Image
                src={src}
                alt={`${t('downloadFrom')} ${alt}`}
                htmlWidth={htmlWidth}
                htmlHeight={htmlHeight}
                loading="lazy"
            />
        </Link>
    );
};
